<template>
  <div class="page" v-cloak>
    <van-nav-bar left-arrow fixed :title=" pageInfo.name || '精选多选一'" id="nav-bar" @click-left="onClickLeft" @click-right="onClickRight">
      <template #right>
        <van-icon size="20" name="phone-o" />
      </template>
    </van-nav-bar>

    <div class="top-bg">
      <img :src="pageInfo.banner" alt="">

    </div>

    <div class="list"> 
        <div class="img-text-row" v-for="(item, index) in goods_list" :key="index">
          <div class="radio" @click="setType(index, item)">
            <img :src="active == index ? radio_active_icon : radio_icon" />
          </div>

          <div class="row-goods-img" @click="setType(index, item)">
            <img :src="item.pic" alt="" />
          </div>

          <!-- <div class="danger" v-if="item.quantity < 1">已售空</div> -->

          <div class="row-goods-info" @click="setType(index, item)">
            <p class="row-goods-name">{{ item.goods_name }}</p>
            <!-- <p class="row-goods-des">{{ item.description }}</p> -->

            <p class="row-goods-original-price">市场价</p>
            <p class="row-goods-price">¥ {{ item.shop_price }}</p>
          </div>
        </div> 
    </div>

    <div class="foot-btn">
      <div class="btn" v-if="active == -1">立即查看</div>
      <div class="btn bg" v-else @click="goDetails">立即查看</div>
    </div>
  </div>
</template>

<script>
import imgTextRow from "@/components/img-text-block/img-text-block.vue";

export default {
  name: "ProductList",
  components: { imgTextRow },
  props: {},
  data() {
    return {
      cardId: this.$route.query.cardId,
      cardProjectId: this.$route.query.cardProjectId,
      // this.$route.query.orderDetail
      active: -1,
      radio_icon: require('../../assets/icon/radio.png'), //radio
      radio_active_icon: require('../../assets/icon/radio-active.png'), //radio active

      goods: {},
      goods_list: [],
      pageInfo:{},

      loading: false,
      finished: false,

      pageNum: 1,
      pageSize: 10,
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      let _this = this;
      let data = {
        card_code: Lockr.get("card_code"),
        card_pwd: Lockr.get("card_pwd"),
      };

      this.$post("/api/exchange_goods_list", data, data).then((res) => { 

        console.log(res.data)

        if (res.data.code == 0) {
          _this.pageInfo  = res.data.data.area;
 
        _this.goods_list = res.data.data.goods_list; 
        } else {
          this.$toast.fail(res.data.message);
          this.finished = true;
        }
      });
    },
    setType(ind, e) {
      this.active = ind;
      this.goods = e;
    },
    goDetails() {
      this.$router.push({
        name: "exchange-goods-details",
        query: {
          goods_id: this.goods.id, 
        },
      });
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.MakeCall(); //拨打电话
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  background-color: #f9f9f9;

  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE */
  scrollbar-width: none; /* Firefox */
  padding: 50px 0;

  .top-bg{
    width: 100%;
    height: 200px;
    img{
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  // 横向
  .img-text-row {
    width: 100%;
    height: 150px;
    background-color: #fff;
    //  background-color: palegoldenrod;
    margin-bottom: 5px;
    padding: 5px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    .danger {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      font-size: 18px;
      color: #fff;
      background-color: rgba(0, 0, 0, 0.2);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .radio {
      width: 18px;
      height: 18px;
      //   background-color: #eee;

      img {
        width: 100%;
        height: 100%;
      }
    }
    .row-goods-img {
      width: 140px;
      height: 140px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .row-goods-info {
      width: 190px;
      height: 100%;
      padding: 5px 0;
      text-align: left;
      //  background-color: paleturquoise;

      .row-goods-leble {
        font-size: 10px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 17px;
        color: #ffffff;
        letter-spacing: 1px;
        text-align: left;

        span {
          padding: 1px 7px;
          border-radius: 3px;
        }

        .rx {
          background-color: #e95970;
        }
        .xs {
          margin-left: 3px;
          background-color: #b80009;
        }
      }
      .row-goods-name {
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 30px;
        color: #333333;
        letter-spacing: 1px;
        display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        -webkit-line-clamp: 2; /*显示的行数；如果要设置2行加...则设置为2*/
        overflow: hidden; /*超出的文本隐藏*/
        text-overflow: ellipsis; /* 溢出用省略号*/
        -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      }
      .row-goods-des {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 20px;
        color: #78849e;
        letter-spacing: 1px;
        display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        -webkit-line-clamp: 2; /*显示的行数；如果要设置2行加...则设置为2*/
        overflow: hidden; /*超出的文本隐藏*/
        text-overflow: ellipsis; /* 溢出用省略号*/
        -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      }
      .row-goods-class {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 20px;
        color: #78849e;
        letter-spacing: 1px;
      }
      .row-goods-original-price {
        text-decoration: line-through;
        font-size: 10px;
        margin-top: 30px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 17px;
        color: #cccccc;
      }
      .row-goods-price {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 30px;
        color: #ff5000;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          font-size: 10px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          line-height: 17px;
          color: #cccccc;
        }
      }
    }
  }
}
.foot-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  padding: 5px 0;
  background-color: #fff;
  .btn {
    margin: 0 auto;
    width: 345px;
    height: 40px;
    background-color: #eee;
    border-radius: 20px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 21px;
    color: #cccccc;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .bg {
    background-color: #ff5000;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
